import type { SampleInfo } from "@/contracts";
import type { SoilDescriptionInputs } from "./types";

export function soilDescriptionInputsFromSample(sample: SampleInfo | undefined): SoilDescriptionInputs {
  return {
    soilFractions: sample?.soilFractions ?? null,
    classifiedSoil: sample?.classifiedSoil ?? null,
    classifiedSoilStandard: sample?.classifiedSoilStandard ?? null,
  };
}
